import { ButtonComponent } from '@/components/commons'
import { useProfile } from 'containers/profile/hooks/useProfile'
import { buttonsVariationMaxWidth } from 'containers/profile/styles/buttons.css'
import { User } from 'containers/user/types/user'

interface ViewProfileButtonProps {
  loading?: boolean
  disabled?: boolean
  profile?: User
  variation?: 'primary' | 'secondary'
  maxWidthClass?: string
}

export const ViewProfileButton = ({
  loading,
  disabled,
  profile,
  variation = 'secondary',
  maxWidthClass = buttonsVariationMaxWidth[130],
}: ViewProfileButtonProps) => {
  const { profile: currentProfile } = useProfile()

  const profileUsing = profile || currentProfile

  return (
    <ButtonComponent
      size="xSmall"
      variation={variation}
      className={maxWidthClass}
      fullWidth
      customSize={{ padding: 2 }}
      label="View Profile"
      disabled={disabled}
      loading={loading}
      to={`/${profileUsing?.username?.toLocaleLowerCase()}`}
    />
  )
}
